import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/affordable-storage-rates.jpg'),
    alt: 'affordable storage rates page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'affordable storage rates page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Storage</span><span>Rates Available Now</span>',
  description:
    'Whether you need to store personal items, business inventory, or seasonal equipment, we provide competitive pricing while keeping your belongings safe.',
  image: {
    url: '/images/v2/pages/landing-pages/affordable-storage-rates/hero-image.jpg',
    alt: 'Affordable Storage Rates Available Now'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Check Affordable Storage Rates' }
}

export const ourProcessSectionContent = {
  title: 'How Affordable Storage Rates Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/affordable-storage-rates/how-affordable-storage-rates-work.png',
    alt: 'How Affordable Storage Rates Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Pricing Plans',
      description:
        'Choose a storage plan that fits your needs and budget. Our rates are designed to accommodate a wide range of storage requirements, with no hidden fees.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-storage-rates/flexible-pricing-plans.png',
        alt: 'Flexible Pricing Plans'
      }
    },
    {
      id: 2,
      title: 'Convenient Payment Options',
      description:
        'Pay monthly or opt for long-term storage with discounts for extended durations. We offer hassle-free payment methods that make budgeting easy.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-storage-rates/convenient-payment-options.png',
        alt: 'Convenient Payment Options'
      }
    },
    {
      id: 3,
      title: 'Safe and Secure Storage',
      description:
        'Enjoy peace of mind knowing your items are stored in a secure, climate-controlled facility with 24/7 surveillance, all at affordable rates.',
      image: {
        src: '/images/v2/pages/landing-pages/affordable-storage-rates/safe-and-secure-storage.png',
        alt: 'Safe and Secure Storage'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Find Affordable Storage Rates Now',
  description:
    'Affordable storage rates help you save money while ensuring that your items are kept safe, secure, and easily accessible. Whether you need storage for personal or business use, finding a cost-effective solution is key to managing your space and finances efficiently.',
  image: {
    src: '/images/v2/pages/landing-pages/affordable-storage-rates/find-affordable-storage-rates-now.jpg',
    alt: 'Find Affordable Storage Rates Now'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Affordable Storage Rates',

  cards: [
    {
      id: 1,
      title: 'Cost Savings',
      description:
        'Our competitive pricing ensures you get the best value for your storage needs, without sacrificing quality or security.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Cost Savings'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        'With affordable rates, you can choose from a variety of unit sizes, whether you need just a small space or a larger storage area.',
      image: {
        src: '/images/v2/pages/common/improved-organization.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 3,
      title: 'Convenient Access',
      description:
        'Access your items whenever you need them, with no added fees for accessing your unit during regular business hours.',
      image: {
        src: '/images/v2/pages/common/flexible-storage-duration.png',
        alt: 'Convenient Access'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Affordable Storage Rates?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students',
          description: 'Store your belongings for the summer or during a move without straining your budget.'
        },
        {
          id: 2,
          title: 'Small Businesses',
          description:
            'Affordable storage options for inventory, equipment, and office supplies, helping your business run smoothly while saving money.'
        },
        {
          id: 3,
          title: 'Homeowners',
          description:
            'Store seasonal items, furniture, or clutter without paying high fees for space you don’t need year-round.'
        },
        {
          id: 4,
          title: 'E-commerce Sellers',
          description: 'Keep your stock and supplies organized and accessible while keeping overhead costs low.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/affordable-storage-rates/who-should-use-affordable-storage-rates.jpg',
        alt: 'Who Should Use Affordable Storage Rates?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Affordable Storage Services',

  cards: [
    {
      id: 1,
      title: 'Personal Storage Solutions',
      description:
        "Whether it's for seasonal clothing, furniture, or personal items, we offer affordable rates on small and large storage units.",
      image: {
        src: '/images/v2/pages/common/personal-storage-solutions.png',
        alt: 'Personal Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Climate-Controlled Storage',
      description:
        'Keep sensitive items like electronics or antiques safe in a climate-controlled storage unit at a budget-friendly price.',
      image: {
        src: '/images/v2/pages/common/climate-controlled-storage.png',
        alt: 'Climate-Controlled Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage Options',
      description:
        'From office documents to inventory, our affordable storage solutions help keep your business organized and cost-efficient.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Short-Term Storage',
      description:
        'Perfect for those in need of temporary space, we offer flexible short-term storage at affordable rates.',
      image: {
        src: '/images/v2/pages/common/short-term-document-storage.png',
        alt: 'Short-Term Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Affordable Storage Rates?',

  image: {
    url: '/images/v2/pages/landing-pages/affordable-storage-rates/why-choose-us-for-affordable-storage-rates.jpg',
    alt: 'Why Choose Us for Affordable Storage Rates?'
  },

  articles: [
    {
      id: 1,
      title: 'Transparent Pricing',
      description:
        'Enjoy clear, upfront pricing with no hidden fees. We offer affordable rates for all types of storage, whether short-term or long-term.'
    },
    {
      id: 2,
      title: 'Convenient Access',
      description:
        'Access your items whenever you need, with no extra charges for visiting your storage unit during regular hours.'
    },
    {
      id: 3,
      title: 'Secure Storage',
      description:
        'Your items are safe in our monitored, climate-controlled facilities, ensuring peace of mind at an affordable price.'
    },
    {
      id: 4,
      title: 'Flexible Terms',
      description:
        'Enjoy flexibility in storage duration, with month-to-month rental options and discounts for long-term commitments.'
    },
    {
      id: 5,
      title: 'Variety of Options',
      description: 'Choose from a range of unit sizes to meet your specific needs, all with competitive rates.'
    },
    {
      id: 6,
      title: 'Climate-Controlled Storage Options',
      description:
        'We offer climate-controlled storage units to protect sensitive items, ensuring that your belongings are safe.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Affordable Storage Rates For All Your Needs',
  description:
    'Affordable storage rates available for all your needs. Fast and reliable storage solutions for all types of belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/affordable-storage-rates/find-affordable-storage-rates-for-all-your-needs.png',
    alt: 'Find Affordable Storage Rates For All Your Needs'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Saving on Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'We collaborate with top-tier logistics partners to ensure efficient and secure storage services at affordable rates.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx helps us offer timely delivery and pickup services for your stored items, making it easier and more affordable to manage your storage needs.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL ensures that your items are stored and shipped securely, offering reliable delivery services at an affordable rate.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides efficient, cost-effective shipping and storage services to help you save on storage and transportation expenses.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
